<ejs-chart *ngIf="chartData" [useGroupingSeparator]="groupingSeparator" [primaryXAxis]="primaryXAxis" [title]="title" [tooltip]="tooltip">
  <e-series-collection>
    <e-series [dataSource]="chartData" type="Bar" xName="label" yName="count" name="Properties" [marker]="marker"></e-series>
  </e-series-collection>
</ejs-chart>
